

import { useEffect, useState } from "react";



export function MyButton(props) {
  const [isClicked, setIsClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsClicked(false);
  };

  const handleMouseDown = () => {
    setIsClicked(true);
  };
  const handleMouseUp = () => {
    setIsClicked(false);
    props.onClick();
  };
  useEffect(() => { }, [isClicked, isHovered])

  return (
    <div className='w-[188px] h-[58px] ' style={{ cursor: "pointer", backgroundImage: `url(${process.env.PUBLIC_URL}/images/download${isClicked ? "click" : isHovered ? "hover" : "normal"}.png)` , backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%", }} onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
    </div>

  )
}


export function ToWeb(props) {
  const [isClicked, setIsClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsClicked(false);
  };

  const handleMouseDown = () => {
    setIsClicked(true);
  };
  const handleMouseUp = () => {
    setIsClicked(false);
    props.onClick();
  };
  useEffect(() => { }, [isClicked, isHovered])

  return (
    <div className='w-[188px] h-[58px] ' style={{
      cursor: "pointer" ,backgroundImage: `url(${process.env.PUBLIC_URL}/images/web${isClicked ? "click" : isHovered ? "hover" : "normal"}.png)`
   , backgroundRepeat: "no-repeat",
      backgroundSize: "100% 100%", }} onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
    </div>

  )
}